<template>
    <div class="mdl-grid">
      <div class="mdl-cell mdl-cell--4-col">
        <div class="mdl-card fill mdl-shadow--2dp ga-tall-card">
          <div class="mdl-tabs mdl-js-tabs">
            <div class="mdl-tabs__tab-bar ga-form-title">
              <a href="#details" class="mdl-tabs__tab is-active">{{'payment.label.details' | label }}</a>
              <a href="#faq" class="mdl-tabs__tab">{{'payment.label.faq' | label }}</a>
            </div>
            <div class="mdl-tabs__panel is-active" id="details">
              <payment-details :service="serviceCode"></payment-details>
            </div>
            <div class="mdl-tabs__panel" id="faq">
              <faq :service="serviceCode"></faq>
            </div>
          </div>
        </div>
      </div>
      <div class="mdl-cell mdl-cell--4-col rel">
        <div class="mdl-card fill mdl-shadow--2dp">
          <div class="ga-form-title">
            <h2 class="ga-title-text" v-show="!isDonation">{{'payment.label.title' | label }}</h2>
            <h2 class="ga-title-text" v-show="isDonation">{{'payment.label.title.donate' | label }}</h2>
          </div>
          <div class="mdl-card__supporting-text fill">
            <!--<ul v-if="user.service === 'SCHEDULED'" class="mdl-list">-->
              <!--<li class="mdl-list__item">-->
                <!--<label class="mdl-radio mdl-js-radio" for="single">-->
                  <!--<input type="radio" id="single" class="mdl-radio__button" name="billing-period" value="SINGLE" v-model="billingPeriod" checked>-->
                  <!--<span class="mdl-radio__label">{{ 'lookup.billingPeriod.single' | label }}</span>-->
                <!--</label>-->
              <!--</li>-->
            <!--</ul>-->
            <!--<ul v-if="service.code === 'DELAYED'" class="mdl-list">-->
            <ul class="mdl-list">
              <li v-for="option in filterBillingPeriod" class="mdl-list__item"
                  data-val="{{option.value}}">
                <label class="mdl-radio mdl-js-radio" for="{{option.key}}">
                  <input type="radio" id="{{option.key}}" class="mdl-radio__button" name="billing-period" value="{{option.code}}" v-model="billingPeriod" v-on:click="isNextTime(option.code)">
                  <span class="mdl-radio__label">{{option.label | label}}</span>
                </label>
              </li>
            </ul>
          </div>
          <div class="mdl-card__actions pricing">
            <div class="mdl-grid">
              <div class="mdl-cell mdl-cell--9-col">
                <h5>{{ 'payment.label.pricing' | label}}</h5>
              </div>
              <div class="mdl-cell mdl-cell--3-col">
                <h5>{{ service.pricing[billingPeriod] | currency }}</h5>
                <!-- <span>{{ trial }}</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mdl-cell mdl-cell--4-col mdl-shadow--2dp">
        <div class="mdl-card fill fill-height">
          <div class="ga-form-title">
            <h2 v-if="trial" class="ga-title-text">{{'payment.label.trial' | label}}</h2>
            <h2 v-if="!trial" class="ga-title-text">{{'payment.label.information' | label}}</h2>
          </div>
          <subscribe-form :payload="paypalPayload"></subscribe-form>
        </div>
      </div>
      <div v-show="success" class="modal" transition="fade">
        <div class="mdl-dialog">
          <h3 class="mdl-dialog__title"></h3>
          <div class="mdl-dialog__content">
            <p v-if="trial">
              {{ 'payment.message.trial.success'  | label }}
            </p>
            <p v-else>
              {{ 'payment.message.success'  | label }}
              <!-- {{ 'subscription.message.success.keep' | label }}} -->
            </p>
            <p>
              {{ 'profile.message.noMessageModel' | label }}
            </p>
          </div>
          <div class="mdl-dialog__actions">
            <div v-on:click="redirect()" class="mdl-button mdl-js-button mdl-button--colored">{{ 'payment.button.dialog.ok' | label}}</div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  var payment = require('api/Payment')
  var auth = require('api/Auth')
  var api = require('api')
  var local = require('common/store/local')
  var config = require('common/config')
  module.exports = {
    ready: function () {
      var self = this
      window.componentHandler.upgradeAllRegistered()
      var token = this.$route.params.token
      if (token) {
        self.token = token

        if (token === 'success') {
          this.token = local.get('client.payment.token')
          this.onSuccess({
            trial: false
          })
          return
        }

        if (token === 'error') {
          this.token = local.get('client.payment.token')
          this.onError({
            data: 'payment.error.general'
          })
          return
        }

        this.$dispatch('loading', true)
        auth.verify(token, function (context) {
          self.setup(context.service, context.userId)
        }, self.onError)
        api.User.profileByToken({token: this.$route.params.token}).then(response => {
          this.payingUser = response.data
        }).catch((err) => {
          console.error('Error retrieving paying user...', err)
        })
      }
    },
    components: {
      subscribeForm: require('c/forms/SubscribeForm'),
      'payment-details': require('c/segments/PaymentDetails'),
      'faq': require('c/segments/FAQ')
    },
    events: {
      'payload': function (payload) {
        if (this.userId !== '') {
          payload.userId = this.userId
        } else {
          payload.userId = this.user.id
        }
        payload.services = [this.service.code]
        payload.billingPeriod = this.billingPeriod
        // payment.submit(payload, this.onSuccess, this.onError)
        if (payload.trial) {
          payment.activateTrial(
            payload,
            () => this.onSuccess(payload),
            this.onError
          )
        } else {
          payment.confirmPayment(
            payload,
            () => this.onSuccess(payload),
            this.onError
          )
        }
      },
      'bitcoin': function () {
        local.put('client.payment.token', this.token)
        var payload = {}
        payload.userId = this.user.id
        payload.services = [this.service.code]
        payload.billingPeriod = this.billingPeriod
        payment.getCoinPaymentsCheckout(payload, function (resp) {
          window.location.href = resp.data
        }, this.onError)
      },
      'paypal-success': function () {
        this.onSuccess({
          trial: false
        })
      },
      'pay': function (user) {
        var self = this
        this.user = user
        this.userId = user.id
        this.$dispatch('loading', true)
        payment.getPricing(user.service, function (pricing) {
          payment.isTrial(user.service, function (trial) {
            self.service = {
              code: self.user.service,
              pricing: pricing,
              trial: trial
            }
          })
          // self.billingPeriod = Object.keys(pricing)[0]
          payment.getBillingPeriods(user.service, function (billingPeriods) {
            self.billingPeriod = billingPeriods.filter(function (bp) {
              return bp.isActive
            })[0].code
            self.billingPeriodList = billingPeriods
            payment.token(function (token) {
              self.$broadcast('payment-token', token)
            }, self.onError)
          }, self.onError)
        }, self.onError)
      }
    },
    methods: {
      setup: function (service, userId) {
        var self = this
        self.service.code = service
        payment.getPricing(service, function (pricing) {
          self.userId = userId
          payment.isTrial(service, function (trial) {
            self.service = {
              code: service,
              pricing: pricing,
              trial: trial
            }
          })
          // self.billingPeriod = Object.keys(pricing)[0]
          payment.getBillingPeriods(service, function (billingPeriods) {
            self.billingPeriodList = billingPeriods
            self.billingPeriod = billingPeriods.filter(function (bp) {
//              return bp.isActive && (self.service.code === 'SCHEDULED' ^ bp.userReady)
              return bp.isActive
            })[0].code
            payment.token(function (token) {
              self.$broadcast('payment-token', token)
            }, self.onError)
          }, self.onError)
        }, self.onError)
      },
      onSuccess: function (payload) {
        this.$dispatch('loading', false)
        this.$dispatch('payment-done')
        var token = this.token
        if (this.userId) {
          if (!this.isDonation) {
            api.SendConfirmation.send({userId: this.userId, service: this.user.service})
          }
        } else {
          api.SendConfirmation.get({token: token}).then(function () {
            api.UrlAction.invalidate({token: token}) // TODO ?? success/error
          })
        }
        if (payload.trial) {
          this.$dispatch('show-success', 'payment.label.trial.success')
        } else {
          this.$dispatch('show-success', 'payment.label.success')
        }
        this.success = true
        // this.$router.go('/app/login')
      },
      onError: function (resp) {
        this.$dispatch('loading', false)
        this.$dispatch('show-error', resp.data)
        local.put('goto', '/app/sub')
        this.$router.go('/app/login')
      },
      isNextTime: function (val) {
        if (this.isDonation && val === 'NONE') {
          this.$router.go('/app/login')
        }
      },
      redirect: function () {
        if (local.get('client.logged')) this.$dispatch('logout')
        window.location.replace(config.clientHost)
      }
    },
    data: function () {
      return {
        service: {
          pricing: {},
          code: '',
          trial: false
        },
        billingPeriod: '',
        billingPeriodList: [],
        userId: '',
        token: '',
        user: {},
        payingUser: undefined,
        success: false
      }
    },
    computed: {
      isDonation: function () {
        return ['SCHEDULED'].indexOf(this.service.code) > -1
      },
      filterBillingPeriod: function () {
        return this.billingPeriodList.filter(function (bp) {
          return bp.userReady && bp.isActive
        })
      },
      paypalPayload: function () {
        const bp = this.billingPeriodList.filter(item => item.code === this.billingPeriod)[0]
        const label = bp ? bp.label : undefined
        if (!this.payingUser) return
        return {
          billingPeriod: this.billingPeriod,
          service: this.service.code,
          user: this.payingUser,
          trial: (this.service.trial ? this.service.trial[this.billingPeriod] : false),
          pricing: this.service.pricing[this.billingPeriod],
          itemLabel: label
        }
      },
      serviceCode: function () {
        return this.service.code
      },
      trial: function () {
        return (this.service.trial ? this.service.trial[this.billingPeriod] : false)
      }
    }
  }
</script>

<style scoped>
.pricing {
  border-top: 1px solid silver;
  color: gray;
  /*font-weight: bold;*/
}
.mdl-dialog {
  width: auto;
  height: 100%;
}
.fill-height {
  min-height: 100%;
}
</style>



// WEBPACK FOOTER //
// Payment.vue?50e36318